import { getAPIV3Pooling } from '@/api'
import APIUrls from '@/config/simpliciti-apis.js'
import { getNestedValue } from '~/utils/object'

export function normalizeDriverToV2(d, categoryList) {
  const categoryId = parseInt(
    getNestedValue(d, '_links.category.href').match(/\d+/)[0]
  )
  const category = categoryList.find((d) => d.id === categoryId)
  let result = {
    id: getNestedValue(d, 'id'),
    chauffeur_categorie_id: categoryId,
    chauffeur_categorie_nom: category?.libelle,
    nom: getNestedValue(d, 'name'),
    matricule: getNestedValue(d, 'matricule'),
    numero_carte: getNestedValue(d, 'numero_carte'),
    code_rfid: getNestedValue(d, 'code_rfid'),
    tel_portable: getNestedValue(d, 'tel_portable'),
  }

  if (category?.parent_id) {
    const parentCategory =
      categoryList.find((c) => c.id === category.parent_id) || null
    result = {
      ...result,
      parentCategoryName: parentCategory ? parentCategory.libelle : '',
    }
  }

  return result
}

export function normalizeDriverCategoryToV2(c) {
  const parentId = getNestedValue(c, 'parentId')
  let result = {
    id: getNestedValue(c, 'id'),
    libelle: getNestedValue(c, 'label'),
    parent_id: parentId == '' ? null : parentId,
    privee: getNestedValue(c, 'private'),
    default: getNestedValue(c, 'default'),
    client: getNestedValue(c, 'clientId'),
  }

  return result
}

export async function fetchDriverCategories(transform = null) {
  return await getAPIV3Pooling({
    uri: `${APIUrls.APIV3_DRIVER_CATEGORIES}?page=1&itemsPerPage=250&order[label]=asc`,
    transform: transform,
  })
}

export async function fetchDrivers(transform = null) {
  return await getAPIV3Pooling({
    uri: `${APIUrls.APIV3_DRIVERS}?page=1&itemsPerPage=250&order[name]=asc`,
    transform: transform,
  })
}

export default {
  fetchDriverCategories,
  fetchDrivers,
  normalizeDriverCategoryToV2,
  normalizeDriverToV2,
}
